import React, { Component } from "react";

export default class DesignImg extends Component {
  render() {
    const theme = this.props.theme;
    const primary = theme.imageHighlight || "#0E6BA8";
    const accent = theme.headerColor || "#0E6BA877";
    const surface = theme.body || "#ffffff";
    const ink = theme.text || "#001C55";

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80%"
        height="auto"
        viewBox="0 0 500 400"
        fill="none"
        aria-label="Graphics, AR/VR/MR — Metal mesh and AR headset"
      >
        <defs>
          <linearGradient id="metal-grad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor={primary} stopOpacity="0.95" />
            <stop offset="100%" stopColor={primary} stopOpacity="0.45" />
          </linearGradient>
        </defs>

        <ellipse cx="250" cy="370" rx="180" ry="14" fill={accent} opacity="0.4" />

        {/* AR / Vision Pro style headset */}
        <g transform="translate(120,200)">
          <ellipse cx="50" cy="22" rx="60" ry="32" fill={ink} opacity="0.92" />
          <ellipse cx="22" cy="22" rx="20" ry="14" fill={primary} />
          <ellipse cx="78" cy="22" rx="20" ry="14" fill={primary} />
          <ellipse cx="22" cy="22" rx="8" ry="6" fill={surface} opacity="0.9" />
          <ellipse cx="78" cy="22" rx="8" ry="6" fill={surface} opacity="0.9" />
          <path
            d="M-10,22 C-10,2 18,-12 50,-12 C82,-12 110,2 110,22"
            stroke={ink}
            strokeWidth="3"
            fill="none"
            opacity="0.85"
          />
        </g>

        {/* 3D wireframe cube (Metal mesh) */}
        <g transform="translate(330,150)">
          {/* back face */}
          <polygon
            points="0,0 80,0 80,80 0,80"
            fill={primary}
            opacity="0.18"
            stroke={primary}
            strokeWidth="1.5"
          />
          {/* front face offset */}
          <polygon
            points="-30,30 50,30 50,110 -30,110"
            fill="url(#metal-grad)"
            stroke={primary}
            strokeWidth="2"
          />
          {/* connecting edges */}
          <line x1="0" y1="0" x2="-30" y2="30" stroke={primary} strokeWidth="2" />
          <line x1="80" y1="0" x2="50" y2="30" stroke={primary} strokeWidth="2" />
          <line x1="80" y1="80" x2="50" y2="110" stroke={primary} strokeWidth="2" />
          <line x1="0" y1="80" x2="-30" y2="110" stroke={primary} strokeWidth="2" />
          {/* mesh diagonals on front face */}
          <line x1="-30" y1="30" x2="50" y2="110" stroke={surface} strokeWidth="1" opacity="0.5" />
          <line x1="50" y1="30" x2="-30" y2="110" stroke={surface} strokeWidth="1" opacity="0.5" />
          <line x1="10" y1="30" x2="10" y2="110" stroke={surface} strokeWidth="1" opacity="0.4" />
          <line x1="-30" y1="70" x2="50" y2="70" stroke={surface} strokeWidth="1" opacity="0.4" />
        </g>

        {/* triangular Metal logo accent */}
        <g transform="translate(80,90)">
          <polygon points="0,0 50,0 25,40" fill={primary} opacity="0.85" />
          <polygon points="10,8 40,8 25,30" fill={surface} opacity="0.9" />
        </g>

        {/* sparkle / lens flare */}
        <g transform="translate(380,80)">
          <circle r="6" fill={primary} />
          <line x1="-14" y1="0" x2="14" y2="0" stroke={primary} strokeWidth="2" opacity="0.7" />
          <line x1="0" y1="-14" x2="0" y2="14" stroke={primary} strokeWidth="2" opacity="0.7" />
        </g>

        {/* color spectrum dots (LUT filters) */}
        <g transform="translate(80,300)">
          <circle cx="0" cy="0" r="8" fill="#FF3B30" />
          <circle cx="20" cy="0" r="8" fill="#FF9500" />
          <circle cx="40" cy="0" r="8" fill="#FFCC00" />
          <circle cx="60" cy="0" r="8" fill="#34C759" />
          <circle cx="80" cy="0" r="8" fill="#5AC8FA" />
          <circle cx="100" cy="0" r="8" fill="#5856D6" />
          <circle cx="120" cy="0" r="8" fill="#AF52DE" />
        </g>
      </svg>
    );
  }
}
